import { Container } from '@cgs/wge';
import { PerformanceMonitor } from './performance-monitor.service';
import { SLOT_GAME_BUILDER_TOKEN, SlotGameBuilder } from '../../slot-game-builder';

export const TEST_PERFORMANCE_MONITOR_COMPONENT_TOKEN = Symbol(
  'TEST_PERFORMANCE_MONITOR_COMPONENT_TOKEN'
);

export class TestPerformanceMonitorComponent {
  private monitor: PerformanceMonitor | null = null;
  private monitorEl: HTMLElement | null = null;
  private readonly builder: SlotGameBuilder;

  constructor(container: Container) {
    this.builder = container.resolve<SlotGameBuilder>(SLOT_GAME_BUILDER_TOKEN);

    document.addEventListener('keydown', (e) => {
      if (e.code === 'KeyP') {
        this.toggle();
      }
    });
  }

  private toggle(): void {
    if (!this.monitor) {
      this.monitor = new PerformanceMonitor({ spriteBatch: this.builder.spriteBatch });
      this.monitorEl = document.body.lastElementChild as HTMLElement;
      return;
    }

    if (this.monitorEl) {
      this.monitorEl.style.display = this.monitorEl.style.display === 'none' ? '' : 'none';
    }
  }
}
